module.exports = __webpack_public_path__ + "img/7-l.1ecd3b93.png";